import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "./data";

export const StickyCtas = () => (
    <>
        <div
            data-testid="sticky-mobile-bar"
            className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-[#D4AF37]/30 md:hidden"
        >
            <a
                href={PHONE_TEL}
                data-testid="sticky-call-button"
                className="flex items-center justify-center gap-2 bg-[#D4AF37] py-4 text-sm font-extrabold text-[#2C2A29]"
            >
                <Phone className="h-5 w-5" />
                Call Now
            </a>
            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sticky-whatsapp-button"
                className="flex items-center justify-center gap-2 bg-[#25D366] py-4 text-sm font-extrabold text-white"
            >
                <MessageCircle className="h-5 w-5" />
                WhatsApp
            </a>
        </div>
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl ring-4 ring-[#25D366]/25 transition-transform duration-200 hover:-translate-y-1 md:flex"
        >
            <MessageCircle className="h-7 w-7" />
        </a>
    </>
);
